// Eén knop voor het zijmenu van de app en het menu op de site. Die waren twee
// losse implementaties met verschillende markup: de app had de tekst "Menu",
// de site drie balkjes met een aria-label. Elke toegankelijkheidsfix moest
// daardoor twee keer, en de tweede werd een keer vergeten.
//
// Balkjes plus het woord: herkenbaar én benoembaar, en daarmee heeft de knop
// een toegankelijke naam uit zijn eigen inhoud in plaats van uit een aria-label
// dat uit de pas kan lopen met wat er staat. Het woord blijft staan als het
// menu open is, want een wisselend label verspringt in breedte; de staat zit in
// aria-expanded.
export function MenuToggle({
  open,
  onToggle,
  controls,
  className,
}: {
  open: boolean;
  onToggle: () => void;
  controls: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      className={`menu-toggle${open ? ' is-open' : ''}${className ? ` ${className}` : ''}`}
      aria-expanded={open}
      aria-controls={controls}
      onClick={onToggle}
    >
      <span className="menu-toggle-bars" aria-hidden="true">
        <span className="menu-toggle-bar" />
        <span className="menu-toggle-bar" />
        <span className="menu-toggle-bar" />
      </span>
      Menu
    </button>
  );
}
